import { takeEvery, all, call, put, select } from 'redux-saga/effects'

import * as actions from './actions'
import { setCommonError } from '../Common/actions'
import * as URL from './url'
import { api } from '../api'
import { util } from '../../util'

function* fetchStoresEquipments() {
    try {
        yield put(actions.equipmentsLoadingStart())
        let {
            data: {
                equipments: { equipments },
            },
        } = yield call(api, URL.getStoreEquipmentsURL, 'GET')
        equipments = equipments.map(options => ({ ...options, key: options.name }))
        const currFilters = yield select(({ stores }) => stores.store_filters)
        const filters = util.configureStoreOptions(currFilters, equipments, 'equipments')
        yield put(
            actions.fetchStoreEquipmentsSuccess({
                store_equipments: equipments,
                store_filters: filters,
                equipments_loading: false,
            })
        )
    } catch (error) {
        console.log('error', error)
        yield put(actions.equipmentsLoadingEnd())
    }
}

function* fetchStoreMarketplaces() {
    try {
        yield put(actions.marketplaceLoadingStart())
        let {
            data: { marketplaces },
        } = yield call(api, URL.getStoreMarketplaces, 'GET')
        marketplaces = marketplaces.map(({ id, display_name }) => ({
            _id: id,
            name: display_name,
            key: id,
        }))
        yield put(
            actions.fetchMarketplaceSuccess({
                marketplaces: marketplaces,
                marketplaces_loading: false,
            })
        )
    } catch (error) {
        console.log('fetch Store Marketplaces error', error)
        yield put(actions.marketplaceLoadingEnd())
    }
}

function* fetchStoresList(action) {
    try {
        const isSideMenuOpened = yield select(util.isSideMenuOpened)
        if (isSideMenuOpened) {
            return
        }
        yield put(actions.storesLoadingStart())
        const { data } = yield call(api, URL.getStoresListURL, 'POST', action.payload)
        yield put(
            actions.fetchStoresSuccess({
                stores_list: data.stores,
                count: data.count,
                size: action.payload.size,
                pageNo: data.pageNo,
                order: action.payload.sort[Object.keys(action.payload.sort)[0]],
                orderBy: Object.keys(action.payload.sort)[0],
            })
        )
    } catch (e) {
        console.log('fetch stores error', e)
        yield e && e.message && put(actions.setStoreError(e.message))
        yield put(actions.storesLoadingEnd())
    }
}

function* fetchStoreByID(action) {
    try {
        yield put(actions.storesLoadingStart())
        const { data } = yield call(api, URL.getStoreByIdURL, 'POST', action.payload)
        if (!data) {
            throw Error('No record')
        }
        yield put(actions.fetchStoreByIDSuccess(data))
    } catch (e) {
        console.log('FETCH STORE BY ID ERROR', e)
        if (e.data && e.data.message && e.data.message === 'Store does not exists') {
            yield put(setCommonError(e.data.message))
        }
        yield put(actions.fetchStoreByIDFailed())
    }
}

function* fetchStoreCities() {
    try {
        yield put(actions.storeCitiesLoadingStart())
        const {
            data: { cities },
        } = yield call(api, URL.getStoreCitiesURL, 'GET')
        const currFilters = yield select(util.getReduxStoreFilters)
        const updatedFilters = currFilters.map(filter => {
            const cloneFilter = { ...filter }
            if (cloneFilter.key === 'city') {
                cloneFilter['baseFilterList'] = cities.map(city => {
                    city = city.trim().toLowerCase()
                    return util.capitalizeWordsInSentence(city)
                })
            }
            return cloneFilter
        })
        yield put(actions.dispatchStoreFilters(updatedFilters))
        yield put(actions.storeCitiesLoadingEnd())
    } catch (error) {
        yield put(actions.storeCitiesLoadingEnd())
        console.log('fetch store cities error', error)
    }
}

function* fetchStorePostalCodes() {
    try {
        yield put(actions.storeZipCodesLoadingStart())
        const {
            data: { zip_codes },
        } = yield call(api, URL.getStorePostalCodesURL, 'GET')
        const currFilters = yield select(util.getReduxStoreFilters)
        const updatedFilters = currFilters.map(filter => {
            const cloneFilter = { ...filter }
            if (cloneFilter.key === 'zip') {
                cloneFilter['baseFilterList'] = zip_codes
            }
            return cloneFilter
        })
        yield put(actions.dispatchStoreFilters(updatedFilters))
        yield put(actions.storeZipCodesLoadingEnd())
    } catch (error) {
        yield put(actions.storeZipCodesLoadingEnd())
        console.log('fetch postal codes error', error)
    }
}

function* fetchStoreDevices() {
    try {
        let {
            data: { devices },
        } = yield call(api, URL.getStoreDevicesURL, 'GET')
        yield put(
            actions.fetchDevicesSuccess({
                devices,
            })
        )
    } catch (error) {
        console.log('fetch Store Devices error', error)
    }
}

export default function* watchStores() {
    yield all([
        takeEvery(actions.actionTypes.SAGA_FETCH_STORE_EQUIPMENTS, fetchStoresEquipments),
        takeEvery(actions.actionTypes.SAGA_FETCH_STORES, fetchStoresList),
        takeEvery(actions.actionTypes.SAGA_FETCH_STORE_BY_ID, fetchStoreByID),
        takeEvery(actions.actionTypes.SAGA_FETCH_STORE_CITIES, fetchStoreCities),
        takeEvery(actions.actionTypes.SAGA_FETCH_STORE_POSTAL_CODE, fetchStorePostalCodes),
        takeEvery(actions.actionTypes.SAGA_FETCH_STORE_MARKETPLACES, fetchStoreMarketplaces),
        takeEvery(actions.actionTypes.SAGA_FETCH_STORE_DEVICES, fetchStoreDevices),
    ])
}
